import { Component, OnInit, inject } from '@angular/core';

import { DrawerModule } from 'primeng/drawer';
import { DashboardLayoutHeaderComponent } from '@core/layout/dashboard-layout/dashboard-layout-header/dashboard-layout-header.component';
import { DashboardLayoutSidebarComponent } from '@core/layout/dashboard-layout/dashboard-layout-sidebar/dashboard-layout-sidebar.component';
import { DashboardLayoutService } from '@core/layout/dashboard-layout/dashboard-layout.service';

@Component({
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.scss'],
  imports: [DrawerModule, DashboardLayoutHeaderComponent, DashboardLayoutSidebarComponent],
  providers: [DashboardLayoutService]
})
export class DashboardLayoutComponent implements OnInit {
  private readonly dashboardLayoutService = inject(DashboardLayoutService);

  sidebarVisible: boolean = false;

  onSidebarToggle() {
    this.sidebarVisible = !this.sidebarVisible;
  }

  ngOnInit(): void {
    this.dashboardLayoutService.redirectToDefaultPage();
  }
}
